"use client";

import * as React from "react";
import { Shirt, Activity, Flag, Zap, ShoppingBag } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
const industries = [{
  name: "Media Partner",
  icon: Shirt
}, {
  name: "Organisasi",
  icon: Activity
}, {
  name: "Pemerintah",
  icon: Flag
}, {
  name: "Komunitas",
  icon: Zap
}, {
  name: "Sponsor",
  icon: ShoppingBag
}];
const brands = [{
  name: "Dewan Pers",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/logo_amazon_white.png"
}, {
  name: "Kominfo",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/logo_target_white.png"
}, {
  name: "PWI Pusat",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/logo_walmart_white.png"
}, {
  name: "AJI Indonesia",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/logo_macys_white.png"
}, {
  name: "IJTI",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/logo_bloomingdales_white.png"
}, {
  name: "Bawaslu",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/logo_nordstrom_white.png"
}, {
  name: "KPU RI",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/logo_tjmaxx_white.png"
}, {
  name: "SMSI",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/logo_dicks_white.png"
}, {
  name: "AMSI",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/logo_pga_white.png"
}];
export default function IndustriesBrands() {
  const [api, setApi] = React.useState<CarouselApi>();
  React.useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [api]);
  return <section data-section-id="79761" id="partner-logos-showcase" className="bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col">
            <div className="mb-8 md:mb-10">
              <h2 className="text-2xl font-serif tracking-tight text-foreground sm:text-3xl lg:text-4xl mb-4">
                Mitra Strategis Kami
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground max-w-md">
                Menjalin kolaborasi erat dengan berbagai sektor untuk menyajikan informasi yang kredibel dan terpercaya bagi masyarakat.
              </p>
            </div>

            <div className="flex flex-col border-t border-border/60">
              {industries.map((industry, i) => {
              const Icon = industry.icon;
              const isActive = i === 0;
              return <div key={industry.name} data-index={i} className={`flex items-center gap-4 py-4 md:gap-6 md:py-6 border-b transition-colors cursor-default px-4 -mx-4 rounded-none group ${isActive ? "border-primary bg-accent/30" : "border-border/60 hover:bg-muted/30"}`}>
                    <div className={`flex items-center justify-center size-10 md:size-12 rounded-full transition-all duration-300 shadow-sm ${isActive ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground group-hover:bg-primary/10 group-hover:text-primary"}`}>
                      <Icon className="size-5" strokeWidth={1.5} />
                    </div>
                    <span className={`text-sm md:text-base font-sans font-medium tracking-tight ${isActive ? "text-foreground" : "text-muted-foreground group-hover:text-foreground"}`}>
                      {industry.name}
                    </span>
                  </div>;
            })}
            </div>
          </div>

          {}
          <div className="relative bg-secondary rounded-none p-8 sm:p-12 lg:p-16 shadow-xl overflow-hidden isolate">
            {}
            <div className="absolute -top-24 -right-24 size-64 sm:size-80 lg:size-96 bg-primary/10 rounded-full blur-3xl pointer-events-none mix-blend-soft-light" />
            <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
            <div className="absolute top-0 left-8 w-px h-full bg-gradient-to-b from-transparent via-primary/20 to-transparent" />

            <div className="relative z-10">
              <h3 className="text-xl md:text-2xl font-serif text-secondary-foreground mb-2">
                Jaringan Kolaborasi
              </h3>
              <p className="text-xs md:text-sm text-secondary-foreground/70 mb-12 max-w-sm">
                Ekosistem kemitraan kami mencakup media nasional, organisasi massa, hingga instansi pemerintah pusat.
              </p>

              <Carousel setApi={setApi} opts={{
              align: "start",
              loop: true
            }} className="w-full">
                <CarouselContent className="-ml-2 sm:-ml-4 md:-ml-6">
                  {brands.map((brand, i) => <CarouselItem key={brand.name} data-index={i} className="pl-2 sm:pl-4 md:pl-6 basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/5">
                      <div className="flex items-center justify-center h-24 md:h-32 p-4 md:p-6 rounded-none bg-secondary-foreground/5 border-none shadow-none hover:shadow-sm backdrop-blur-sm transition-all duration-400 group">
                        <img src={brand.logo} alt={`${brand.name} logo`} className="max-h-8 md:max-h-10 w-auto object-contain opacity-40 grayscale group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-400 brightness-200" />
                      </div>
                    </CarouselItem>)}
                </CarouselContent>
                
                <div className="flex items-center justify-end gap-3 mt-6 md:mt-10">
                  <CarouselPrevious className="static translate-y-0 translate-x-0 bg-transparent border-secondary-foreground/20 text-secondary-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary size-10 transition-colors" />
                  <CarouselNext className="static translate-y-0 translate-x-0 bg-transparent border-secondary-foreground/20 text-secondary-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary size-10 transition-colors" />
                </div>
              </Carousel>
            </div>
          </div>

        </div>
      </div>
    </section>;
}